module.exports = __webpack_public_path__ + "c1b922fd55358fe3e3f02c5525104d63.png";